import React from "react";
import { Box, Icon, Text } from "@showitinc/showit-wc";
import UIActions from "../../actions/UIActions";
import AppConstants from "../../constants/AppConstants";
import styles from "./Panel.module.css";

const { PANEL_LAYERS, PANEL_PAGES, SITE_ITEM_BLOCK, SITE_ITEM_PAGE, SITE_ITEM_CANVAS_SET } =
  AppConstants;

const SitePanelTabset = ({ blockContainer, activeTab }) => {
  const pagesActive = activeTab === PANEL_PAGES;
  const layersActive = activeTab === PANEL_LAYERS;
  const layerType = blockContainer.get("type", SITE_ITEM_PAGE);
  const isBlock = layerType === SITE_ITEM_BLOCK;
  const isCanvasSet = layerType === SITE_ITEM_CANVAS_SET;
  const isBlogTemplate = blockContainer.get("isWP");

  const _togglePanels = ({ activePanel, activePropertiesPanel }) => {
    UIActions.togglePages({ activePanel });
    if (activePropertiesPanel !== undefined) {
      UIActions.togglePropertiesPanel({ name: activePropertiesPanel });
    }
  };

  return (
    <Box
      d="flex"
      justify="between"
      align="center"
      direction="row"
      className={styles.panelTabset}
      data-intercom-target="site panel tabset"
    >
      <Box
        d="flex"
        align="center"
        className={`${styles["panel-tab-text-wrapper"]} ${pagesActive ? styles.active : ""}`}
        onClick={() =>
          _togglePanels({ activePanel: PANEL_PAGES, activePropertiesPanel: SITE_ITEM_PAGE })
        }
        data-intercom-target="site panel tab"
      >
        <Icon
          className={`${styles.panelTab} ${pagesActive ? styles.active : ""}`}
          type="site"
          size="20"
        />
        <Text
          variant="small"
          variantStyle="semi"
          className={`${styles.panelTab} ${pagesActive ? styles.active : ""}`}
        >
          &nbsp;Site
        </Text>
      </Box>
      <Box
        d="flex"
        align="center"
        className={`${styles["panel-tab-text-wrapper"]} ${layersActive ? styles.active : ""}`}
        onClick={() => _togglePanels({ activePanel: PANEL_LAYERS })}
        data-intercom-target="page panel tab"
      >
        <Icon
          className={`${styles.panelTab} ${layersActive ? styles.active : ""}`}
          type={
            isBlock
              ? "siteCanvas"
              : isCanvasSet
              ? "canvasSet"
              : isBlogTemplate
              ? "wordpress"
              : "sitePage"
          }
          size="20"
        />
        <Text
          variant="small"
          variantStyle="semi"
          className={`${styles.panelTab} ${layersActive ? styles.active : ""}`}
        >
          &nbsp;{" "}
          {isBlock ? "Canvas" : isCanvasSet ? "Canvas Set" : isBlogTemplate ? "Template" : "Page"}
        </Text>
      </Box>
    </Box>
  );
};

export default SitePanelTabset;
